import { normalizeQuantity } from './quantity';
import { sanitizeQuantityInput } from './quantityInputParser';

export const resolveMermaProductCategoryId = (product) => (
  product?.categoryId ?? product?.Category?.id ?? null
);

export const getActiveMermaProducts = (products = [], categories = []) => {
  const activeCategoryIds = new Set(
    (Array.isArray(categories) ? categories : [])
      .filter((category) => category?.isActive !== false && category?.id != null)
      .map((category) => String(category.id))
  );

  return (Array.isArray(products) ? products : []).filter((product) => {
    const categoryId = resolveMermaProductCategoryId(product);
    return categoryId != null && activeCategoryIds.has(String(categoryId));
  });
};

export const resolveMermaCategory = (product, categoriesById = new Map()) => {
  const categoryId = resolveMermaProductCategoryId(product);
  if (categoryId == null) return product?.Category || null;
  return categoriesById.get(String(categoryId)) || product?.Category || null;
};

export const sanitizeMermaQuantityInput = (valueOrEvent) => {
  const rawValue = typeof valueOrEvent === 'string' || typeof valueOrEvent === 'number'
    ? valueOrEvent
    : valueOrEvent?.target?.value;
  if (rawValue == null || String(rawValue).trim() === '') return '';
  return sanitizeQuantityInput(rawValue, true);
};

export const normalizeMermaQuantity = (value) => normalizeQuantity(value, 3);

export const buildMermaItemsPayload = (lines = []) => (
  (Array.isArray(lines) ? lines : [])
    .map((line) => ({
      varietyId: Number(line?.varietyId),
      quantity: normalizeMermaQuantity(line?.quantity),
      metricUnit: 'kg',
      reason: 'Merma',
      note: String(line?.note || '').trim() || null,
    }))
    .filter((item) => Number.isInteger(item.varietyId) && item.varietyId > 0 && item.quantity > 0)
);

export const getMermaLineKey = (lineOrVariety) => String(
  lineOrVariety?.varietyId ?? lineOrVariety?.id ?? ''
);
